module.exports = __webpack_public_path__ + "06e37ffc539f846ee9e38c00b595021f.png";